import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// import Sidebar from "./sidebar";
import Sidebar from '../components/sidebar';
import Header from './gapsy-header';
import Navigation from './gapsy-Cnavigation';
import Footer from './gapsy-footer';
import styles from '../assets/css/gapsy-dashboard.module.css';


function GapsyRiskAppetiteReport() {
    const navigate = useNavigate();

    // const username = localStorage.getItem("username");
    // const isDepartmentUser = username === "departmentuser";
    // const isMarketUser = username === "marketriskuser";
    // const isRiskAnalyst = username === "riskanalyst";

    const [activeMenu, setActiveMenu] = useState("");

    const dept = localStorage.getItem("dept");
    const isDepartmentUser = dept === "HR";
    const isMarketUser = dept === "Finance";
    const isRiskAnalyst = dept === "Risk";



    // const [activeLevel, setActiveLevel] = useState(
    //   isDepartmentUser ? "level2a" : "level1"
    // );
    const [activeLevel, setActiveLevel] = useState(() => {
        if (isDepartmentUser) return "level2a";
        if (isMarketUser) return "level1";
        return "level1";
    });

    // const [iframeSrc, setIframeSrc] = useState(
    //   isDepartmentUser
    //     ? "https://public.tableau.com/views/Risk_appetite_monitoring_level2A_daily_newdata/Dashboard1?:showVizHome=no"
    //     : "https://public.tableau.com/views/Risk_appetite_monitoring_quartely1_newdataformat/Dashboard5?:showVizHome=no"
    // );

    const [iframeSrc, setIframeSrc] = useState(() => {
        if (isDepartmentUser) {
            return "https://public.tableau.com/views/Risk_appetite_monitoring_level2A_daily_newdata2/Dashboard1?:showVizHome=no";
        }

        if (isMarketUser) {
            // ✅ Market user default = Level1 Daily
            return "https://public.tableau.com/views/Risk_appetite_monitoring_level1_daily/Dashboard5?:showVizHome=no";
        }

        return "https://public.tableau.com/views/Risk_appetite_monitoring_quartely1_newdataformat/Dashboard5?:showVizHome=no";
    });


    const handleLogout = () => {
        navigate("/");
    };

    const getDefaultIframeByLevel = (level) => {
        switch (level) {
            case "level1":
                if (isDepartmentUser) {
                    return "https://public.tableau.com/views/Risk_appetite_monitoring_level1_daily/Dashboard5?:showVizHome=no";
                }

                if (isMarketUser) {
                    // ✅ Market user Level1 default = Daily
                    return "https://public.tableau.com/views/Risk_appetite_monitoring_level1_daily/Dashboard5?:showVizHome=no";
                }

                return "https://public.tableau.com/views/Risk_appetite_monitoring_quartely1_newdataformat/Dashboard5?:showVizHome=no";

            case "level2a":
                // ✅ Market user default = Daily
                return "https://public.tableau.com/views/Risk_appetite_monitoring_level2A_daily_newdata2/Dashboard1?:showVizHome=no";

            case "level2b":
                // ✅ Market user default = Monthly
                return "https://public.tableau.com/views/Risk_appetite_monitoring_level2B_monthly/Dashboard5?:showVizHome=no";

            default:
                return "";
        }
    };
    const getIframeHeight = () => {
        // Level 1 Quarterly
        if (
            activeLevel === "level1" &&
            activeMenu === "quarterly" &&
            !isDepartmentUser &&
            !isMarketUser
        ) {
            return 533;
        }

        // Level 2A Quarterly
        if (
            activeLevel === "level2a" &&
            activeMenu === "quarterly"
        ) {
            return 533;
        }
        if (
            activeLevel === "level1" &&
            activeMenu === "allbreaches"
        ) {
            return 543;
        }


        return 590;
    };

    return (
        // <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
        <div className={`d-flex flex-column ${styles.pageFullBackground}`}
            style={{ height: "100vh", overflow: "hidden" }}>
            <Header />
            <Navigation />

            <div style={styles1.main}>
                <Sidebar
                    setIframeSrc={setIframeSrc}
                    activeLevel={activeLevel}
                    isDepartmentUser={isDepartmentUser}
                    isMarketUser={isMarketUser}
                    isRiskAnalyst={isRiskAnalyst}
                    activeMenu={activeMenu}
                    setActiveMenu={setActiveMenu}
                />


                <div style={styles1.content}>
                    <div style={styles1.levelTabs}>
                        {[
                            { key: "level1", label: "Level 1" },
                            { key: "level2a", label: "Level 2A" },
                            { key: "level2b", label: "Level 2B" }
                        ].map((tab) => (
                            <button
                                key={tab.key}
                                onClick={() => {
                                    setActiveLevel(tab.key);
                                    setIframeSrc(getDefaultIframeByLevel(tab.key));
                                }}
                                style={{
                                    ...styles1.levelTab,
                                    ...(activeLevel === tab.key ? styles1.levelTabActive : {})
                                }}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* <iframe
                        src={iframeSrc}
                        title="Tableau Dashboard"
                        width="100%"
                        height="553"
                        frameBorder="0"
                        allowFullScreen
                    /> */}
                    {/* <iframe
                        src={iframeSrc}
                        title="Tableau Dashboard"
                        width="100%"
                        height={getIframeHeight()}
                        frameBorder="0"
                        allowFullScreen
                    /> */}
                    <iframe
                        src={iframeSrc}
                        title="Tableau Dashboard"
                        width="100%"
                        height={getIframeHeight()}
                        style={{
                            border: "none",
                            overflow: "auto"
                        }}
                        scrolling="yes"
                        allowFullScreen
                    />
                </div>
            </div>
            {/* <footer style={styles.footer}></footer> */}
            {/* <Footer /> */}

        </div>
    );
}


const styles1 = {
    page: { height: "100vh", display: "flex", flexDirection: "column" },

    header: {
        height: "60px",
        backgroundColor: "#0072DA",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px"
    },

    headerLeft: { display: "flex", alignItems: "center", gap: "12px" },
    logo: { height: "36px" },
    headerTitle: { margin: 0, fontSize: "18px", fontWeight: "600" },

    headerRight: { display: "flex", alignItems: "center", gap: "12px" },
    username: { fontSize: "14px" },

    logoutBtn: {
        padding: "8px 16px",
        backgroundColor: "#ef4444",
        border: "none",
        borderRadius: "4px",
        color: "#fff",
        cursor: "pointer"
    },

    main: { flex: 1, display: "flex", overflow: "hidden" },
    content: { flex: 1, padding: "5px" },

    footer: { height: "10px", backgroundColor: "#0072DA" },
    footer: {
        height: "10px",
        backgroundColor: "#0072DA",
        color: "#fff",
        textAlign: "center",
        lineHeight: "20px",
        fontSize: "14px"
    }, headerRight: {
        display: "flex",
        alignItems: "center",
        gap: "12px"
    },
    username: {
        fontSize: "14px",
        fontWeight: "500"
    },
    /* 🔹 Level tabs */
    levelTabs: {
        display: "flex",
        gap: "10px",
        marginBottom: "0px"
    },
    levelTab: {
        padding: "4px 14px",   // 🔽 reduce vertical padding
        border: "1px solid #0072DA",
        backgroundColor: "#fff",
        color: "#0072DA",
        cursor: "pointer",
        borderRadius: "4px",
        fontWeight: "500",
        fontSize: "13px",      // 🔽 slightly smaller text
        lineHeight: "1.2"
    },
    levelTabActive: {
        backgroundColor: "#0072DA",
        color: "#fff"
    }
};

export default GapsyRiskAppetiteReport;
